<template>
  <div class="about">
    <h1>关于</h1>
    <p>Version is: {{ message }}</p>
   	<input v-model="message" placeholder="1.0.12" />
     <p>Designed and Made by Hexagon IIOT Teams</p>
    
  </div>
</template>


<script>
export default {
  name: 'about',
  data() {
    return {
      message: '2.0.0.20240925'
    }
  },
  mounted(){
    this.$http.get('http://192.168.132.65:5233/api/Polestar/System/Get')
              .then(function (response) {

                console.log(response.data)
                console.log(response.status)
                console.log(response.statusText)
                console.log(response.headers)
                console.log(response.config)

              })
              .catch(function (error) {

                console.log(error);

              });
  }
}
</script>